export default "__VITE_ASSET__C0irE2wo__"